import { createContext, useContext, useState, ReactNode } from 'react';

interface PanelContextType {
  isOpen: boolean;
  title: string;
  content: ReactNode | null;
  openPanel: (title: string, content: ReactNode) => void;
  closePanel: () => void;
}

const PanelContext = createContext<PanelContextType | undefined>(undefined);

export function PanelProvider({ children }: { children: ReactNode }) {
  const [isOpen, setIsOpen] = useState(false);
  const [title, setTitle] = useState('');
  const [content, setContent] = useState<ReactNode | null>(null);

  const openPanel = (title: string, content: ReactNode) => {
    setTitle(title);
    setContent(content);
    setIsOpen(true);
  };

  const closePanel = () => {
    setIsOpen(false);
    setTitle('');
    setContent(null);
  };

  return (
    <PanelContext.Provider value={{ isOpen, title, content, openPanel, closePanel }}>
      {children}
    </PanelContext.Provider>
  );
}

export function usePanel() {
  const context = useContext(PanelContext);
  if (context === undefined) {
    throw new Error('usePanel must be used within a PanelProvider');
  }
  return context;
}
